import { render, staticRenderFns } from "./MintalMesPrdCraftMaterialConfigList.vue?vue&type=template&id=34919c57&"
import script from "./MintalMesPrdCraftMaterialConfigList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdCraftMaterialConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports